import React, {Fragment, useState, useEffect} from 'react';
import Header from './Components/Header';
import Formulario from './Components/Formulario'
import Clima from './Components/Clima'
import Error from './Components/Error'


function App() {

      // state del formulario 
      const [busqueda, guardarBusqueda]= useState({
        ciudad:'',
        pais: ''
    })
    const [consultar, guardarConsultar] = useState(false);
    const [resultado , guardarResultado] = useState({});
    const{ciudad, pais} = busqueda;
    const [error , guardarError] = useState(false);
    
    useEffect(() => {
       
      const consultarApi = async () => {

        if(consultar){
          const appId='b4e9144d798b47ebf4cec4296eca679a';
          const url = `https://api.openweathermap.org/data/2.5/weather?q=${ciudad},${pais}&appid=${appId}`;
  
          const respuesta = await fetch(url);
          const resultado = await respuesta.json(); 
  
          guardarResultado(resultado);
          guardarConsultar(false);

          if(resultado.cod ==='404'){
            guardarError(true);
          }else{
            guardarError(false);
          } 
        }
      }
      consultarApi();
      // eslint-disable-next-line
    }, [consultar]);
      
    let Componente;
    if(error){
        Componente = <Error  mensaje ="no hay resultados"/>
      }else{
        Componente= <Clima resultado={resultado}/>
      }
    
    return (
    <Fragment>
        <Header
          titulo = "Clima React App"
        />
        <div className="contenedor-form">
          <div className="container">
              <div className="row">
                <div className="col m6 s12">
                    <Formulario
                    busqueda={busqueda}
                    guardarBusqueda={guardarBusqueda}
                    guardarConsultar={guardarConsultar}/>
                </div>
                <div className="col m6 s12">
                  {Componente}
                </div>
           
              </div>
              
          </div>

        </div>
   </Fragment>
  );
}

export default App;
